export const APP_CONFIG = {
  name: 'Check Play 簡播',
  shortName: 'Check Play',
  description: 'Check Play 簡播 - 專業影片播放工具',
  version: '0.1112.05',
  author: 'Red Ball Studio',
  copyright: '© 2025 Red Ball Studio | 紅球'
}; 